<template>
    <div class="mainDiv">
        <div class="top-portion">
            <div class="header">
                <img
                    class="backgroundimage"
                    style=""
                    src="../../../assets/LandingPage/headerBackground.png"
                />
                <p class="headerText" >
                    {{ header }}
                </p>
            </div>

            <p class="subheaderText">
                {{ subheader }}
            </p>
            <div class="ctaButtons">
                <div
                    v-if="isMobile"
                    class="CreateAcountbtn"
                    style="cursor: pointer; box-shadow: 3px 3px 11px rgba(28, 50, 27, 0.33)"
                    @click="createAccountMobile()"
                >
                    <p class="CreateAcountbtntext">Create account</p>
                </div>
                <div
                    v-else
                    class="CreateAcountbtn"
                    style="cursor: pointer; box-shadow: 3px 3px 11px rgba(28, 50, 27, 0.33)"
                    @click="createAccountDesktop()"
                >
                    <p class="CreateAcountbtntext">Create account</p>
                </div>
                <div
                    class="requestDemobtn"
                    style="cursor: pointer; "
                    @click="handleclickReachUs()"
                >
                    <p class="requestDemobtntext">Request a demo</p>
                </div>
            </div>
        </div>
        <div class="image-card">
            <img height="100%" width="100%" :src="require(`../../../assets/LandingPage/${src}`)" alt="" />
        </div>
        <div class="image-cardMobile">
            <img height="100%" width="100%" :src="require(`../../../assets/LandingPage/${srcMobile}`)" alt="" />
        </div>
        
    </div>
</template>
<script>
import MoengageEventGenerator from "../../../helpers/moengageEventGenerator";
import MoengageEvents from "../../../helpers/moengageEvents";
import MoengageAtrributes from "../../../helpers/moengageAttributes";
export default {
    name: "tabDetails",
    props: {
        onclickReachUs: {
            type: Function,
            required: true,
        },
        header: {},
        subheader: {},
        src: {},
        srcMobile: {},
    },

    data() {
        return {
            isMobile: false,
        };
    },

    methods: {
        gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },
        goToReachOutToUs() {
            const top = window.innerWidth < 782 ? 5770 : 6500;
            window.scrollTo({ top: top, behavior: "smooth" });
        },
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
        createAccountMobile() {
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Create Account",
                            [MoengageAtrributes.Device]:"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Log In Page",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

            sessionStorage.setItem('buttonType','register');
            this.$router.push({ name: "login" });
        },
        createAccountDesktop() {
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Create Account",
                            [MoengageAtrributes.Device]:"Desktop",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Log In Page",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

            this.$router.push({ name: "login" });
        },
        handleclickReachUs() {
            const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Request A Demo",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.NextActivity]:"Reach Us Section",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

            this.onclickReachUs();
        },
    },
    mounted() {
        this.checkDevices();
    },
};
</script>
<style lang="scss" scoped>
.mainDiv {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    // justify-content: space-between;
    margin: 0px auto;
    gap: 5px;
    text-align: center;
    align-items: center;
}
.top-portion {
    margin-bottom: 60px;
}
.header {
    display: flex;
    justify-content: center;
    margin-top: 68px;
}

.headerText {
    max-width: 973px;
    font-weight: 400;
    font-size: 32px;
    position: relative;
    text-align: center;
    color: #3a3f3a;
    margin-bottom: 37px;
    margin-top: 10px;
   
}
.image-card {
    height: 100%;
    width: 80%;
    // background: #f8f9f8;
    border-radius: 8px;
}
.subheaderText {
    max-width: 973px;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
    color: #797e79;
    margin-bottom: 0px;
}
.ctaButtons {
    display: flex;
    justify-content: center;
    width: 50%;
    margin: 0px auto;
    gap: 30px;
    margin-top: 30px;
}
.CreateAcountbtn {
    display: flex;
    gap: 10px;
    height: 47px;
    background: #339137;
    border-radius: 3px;
    width: 50%;
}
.CreateAcountbtntext {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0px;
    color: #ffffff;
}
.requestDemobtn {
    display: flex;
    height: 47px;
    background: #fbf9d4;
    border-radius: 3px;
    width: 50%;
}
.requestDemobtntext {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 0px;
    line-height: 19px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3a3f3a;
}
@media all and (max-width: 1024px) {
    .image-card {
        display: none;
    }
}
@media all and (max-width: 335px) {
    .ctaButtons {
        margin-top: 30px;
    }
}
@media all and (max-width: 1024px) {
    .top-portion {
        margin-bottom: 32px;
    }
}
@media all and (min-width: 1024px) {
    .image-cardMobile {
        display: none;
    }
}
@media all and (max-width: 1024px) {
    .header {
        justify-content: flex-start;
    }
}
@media all and (max-width: 1024px) {
    .headerText {
        font-size: 20px;
        margin-top: 20px;
        left: 5%;
    }
}
@media all and (max-width: 1024px) {
    .backgroundimage {
        width: 220px;
       // height: 1%;
      
    }
}
.backgroundimage{
    position: absolute;
}
@media all and (max-width: 1024px) {
    .subheaderText {
        text-align: start;
        // max-width: 320px;
        font-size: 18px;
        // display: none;
    }
}
@media all and (max-width: 1024px) {
    .ctaButtons {
        margin: 30px 0px 0px 0px;
        // display: none;
        gap: 20px;
        width: 100% !important;
    }
}
@media all and (max-width: 1024px) {
    .CreateAcountbtn {
        // display: none;
        width: 80% !important;
    }
}
@media all and (max-width: 1024px) {
    .requestDemobtn {
        // display: none;
        width: 80% !important;
    }
}
@media all and (max-width: 1024px) {
    .requestDemobtntext {
        // display: none;
        font-size: 15px;
    }
}
@media all and (max-width: 1024px) {
    .CreateAcountbtntext {
        // display: none;
        font-size: 15px;
    }
}
</style>
